import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.scss';

const Modal = ({ show, onHide, title, children, footer, size = 'md' }) => {
  const handleEscape = useCallback((e) => {
    if (e.key === 'Escape') onHide();
  }, [onHide]);

  useEffect(() => {
    if (show) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [show, handleEscape]);

  if (!show) return null;

  const sizeClass = size === 'sm' ? styles.dialogSm : size === 'lg' ? styles.dialogLg : '';

  return createPortal(
    <div className={styles.overlay} onClick={onHide}>
      <div
        className={`${styles.dialog} ${sizeClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h5 className={styles.title}>{title}</h5>
          <button className={styles.closeBtn} onClick={onHide} aria-label="Close">
            &times;
          </button>
        </div>
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
